import { useQuery } from 'react-query';

import { QueryStateValue } from 'hooks/useQueryState';

import { getTemplate as queryFn } from 'api/endPoints/getTemplate';

import { IGateForMapping } from 'components/pages/PhasePerformanceManagePage/components/Manage/Manage.types';

export const useQueryGetSingleTemplate = (templateId: QueryStateValue, contractId?: QueryStateValue) => {
    return useQuery<IGateForMapping, QueryError>(
        ['phasePerformanceSingleTemplate', templateId],
        () => queryFn(templateId),
        {
            enabled: Boolean(templateId) && !Boolean(contractId),
            cacheTime: 0,
        },
    );
};
